import React from 'react';
import { Trans } from 'react-i18next';
import { OrderDeliveryType } from '@1po/1po-bff-fe-spec/generated/order/response/GetDealerOrderPageResponse';
import { OrderReferenceItem } from '@1po/1po-bff-fe-spec/generated/order/response/model/OrderItem';
import { DEALER_PICKUP, EXADIS_PICKUP_DELIVERY_TYPE, OWN_ADDRESS } from 'domains/basket/Basket.types';
import { OrderReferenceItemLocal } from 'domains/order/Order.types';

export const getDeliveryTypeLabel = (deliveryType: OrderDeliveryType) => {
  switch (deliveryType) {
    case DEALER_PICKUP:
      return <Trans i18nKey={'order.delivery_type.dealer_pickup'}>Dealer pickup</Trans>;
    case OWN_ADDRESS:
      return <Trans i18nKey={'order.delivery_type.delivery_to_address'}>Delivery to address</Trans>;
    case EXADIS_PICKUP_DELIVERY_TYPE:
      return <Trans i18nKey={'order.delivery_type.exadis_counter_pickup'}>Exadis counter pickup</Trans>;
    default:
      return 'unknown';
  }
};

export const getDeliveryTypes = (
  orderReferences: OrderReferenceItemLocal[] | OrderReferenceItem[],
  defaultDeliveryType: OrderDeliveryType,
): OrderDeliveryType[] => {
  const allDeliveries = orderReferences.map((x) => x.deliveryType);
  const allDefinedDeliveries = allDeliveries.filter((x) => x !== undefined) as OrderDeliveryType[];
  const uniqueDeliveries = new Set(allDefinedDeliveries);
  if (allDefinedDeliveries.length === 0) {
    return [defaultDeliveryType];
  } else {
    return [...uniqueDeliveries];
  }
};
